export const styles = {
    contentHeaderWrapper: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        paddingBottom: '32px',
    },
    contentBodyWrapper: {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        boxShadow: ' 0 0 9px #9c9c9c61',
    },
    addTable: {
        width: ' 100%',
        p: '30px 60px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    backButton: {
        width: '100px',
        color: '#3F455A',
    },
    addTableTitle: {
        color: '#3F455A',
    },
    basicInformation: {
        width: '100%',
        m: '40px 0',
    },
    basicInformationText: {
        color: '#9AA1B7',
    },
    display: 'flex',
    inputBox: {
        flexWrap: 'wrap',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        pt: '20px',
    },
    inputs: {
        width: '400px',
        mb: '50px',
    },
    removeButtonBox: {
        width: '400px',
    },
    removeButton: {
        color: '#7C85A2',
    },
    bottomBLine: {
        width: '100%',
        height: '1px',
        background: '#C1C4CC',
        mt: '30px',
    },
    inputsAdditionalPreOfferBox: {
        flexWrap: 'wrap',
        pt: '15px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    inputsAdditionalPreOffer: {
        width: '400px',
        m: '5px 0',
    },
    additionalPreOfferButton: {
        flexWrap: 'wrap',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mt: '20px',
    },
    createButtonBox: {
        width: '100%',
        pt: '10px',
        display: 'flex',
        justifyContent: 'flex-end',
        mt: '5px',
    },
    createButton: {
        mt: '10px',
    },
};
